import { __decorate, __metadata } from "tslib";
import { Component, Model, Prop, Ref, Watch } from "vue-property-decorator";
import LvButton from "../button/LvButton.vue";
import LvIcon from "../icon/LvIcon.vue";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvFilePicker";
/**
 * A component to pick files.
 * <br>This component does not handle the upload of files.
 */
let LvFilePicker = class LvFilePicker extends UIComponent {
    constructor() {
        super(...arguments);
        this.selectedFiles = [];
    }
    get accept() {
        return this.fileTypes.join(",");
    }
    /**
     * Reset the list of selected files
     */
    reset() {
        this.selectedFiles = [];
        this.resetNativeInput();
        this.$emit("change", this.multiple ? this.selectedFiles : null);
    }
    onModelChange(newValue, oldValue) {
        if (newValue == oldValue)
            return;
        if (newValue instanceof Array) {
            this.selectedFiles = newValue;
        }
        else if (newValue instanceof File) {
            this.selectedFiles = [newValue];
        }
        else {
            this.selectedFiles = [];
        }
    }
    onFileInputChange(ev) {
        if (!this.multiple) {
            this.selectedFiles = [];
        }
        if (this.fileInput.files) {
            const files = Array.from(this.fileInput.files);
            this.processAddedFiles(files);
        }
        this.resetNativeInput();
    }
    processAddedFiles(files) {
        for (const file of files) {
            if (this.maxSize != null) {
                if (file.size > this.maxSize)
                    continue;
            }
            this.selectedFiles.push(file);
        }
        this.$emit("change", this.multiple ? this.selectedFiles : this.selectedFiles[0] ?? null);
    }
    resetNativeInput() {
        this.fileInput.value = null;
    }
    isNativeFile(file) {
        return file instanceof File;
    }
    getFileIcon(file) {
        if (file.type.startsWith("image"))
            return "las la-image";
        else if (file.type.startsWith("video"))
            return "las la-film";
        else if (file.type.startsWith("audio"))
            return "las la-file-audio";
        else
            return "las la-file-alt";
    }
};
__decorate([
    Ref(),
    __metadata("design:type", HTMLInputElement)
], LvFilePicker.prototype, "fileInput", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: () => false }),
    __metadata("design:type", Boolean)
], LvFilePicker.prototype, "multiple", void 0);
__decorate([
    Prop({ type: Array, required: false, default: () => [] }),
    __metadata("design:type", Array)
], LvFilePicker.prototype, "fileTypes", void 0);
__decorate([
    Prop({ type: Number, required: false, default: () => null }),
    __metadata("design:type", Object)
], LvFilePicker.prototype, "maxSize", void 0);
__decorate([
    Model("change"),
    __metadata("design:type", Object)
], LvFilePicker.prototype, "model", void 0);
__decorate([
    Watch("model"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], LvFilePicker.prototype, "onModelChange", null);
LvFilePicker = __decorate([
    Component({
        name: COMPONENT_NAME,
        components: { LvIcon, LvButton },
    })
], LvFilePicker);
export default LvFilePicker;
//# sourceMappingURL=script.js.map